const SCALE_RATIO = 100 / 255;
const scaleToHsl = (value) => value * SCALE_RATIO;

export const HSL_LIGHTNESS_RULES = {
    BASIC_LIGHTNESS: {
        condition: (global, _partitions) => {
            const rules = [];
            const level = global?.lightness?.level;
            const dynamicRange = global?.lightness?.dynamicRange;

            if (!level || !dynamicRange) return rules;

            if (level === 'DARK') {
                if (dynamicRange === 'COMPLETE') rules.push('darkComplete');
                else if (dynamicRange === 'LIMITED') rules.push('darkLimited');
                else if (dynamicRange === 'PARTIAL') rules.push('darkPartial');
            } else if (level === 'BRIGHT') {
                if (dynamicRange === 'COMPLETE') rules.push('brightComplete');
                else if (dynamicRange === 'LIMITED') rules.push('brightLimited');
                else if (dynamicRange === 'PARTIAL') rules.push('brightPartial');
            } else if (level === 'NEUTRAL') {
                if (dynamicRange === 'COMPLETE') rules.push('neutralComplete');
                else if (dynamicRange === 'LIMITED') rules.push('neutralLimited');
                else if (dynamicRange === 'PARTIAL') rules.push('neutralPartial');
            }

            return rules;
        }
    },
    FEATURE_RULES: {
        condition: (global, partitions) => {
            const features = [];
            const blacksMean = partitions?.blacks?.lightness?.statistics?.mean;
            const highlightsMean = partitions?.highlights?.lightness?.statistics?.mean;
            const shadowsStd = partitions?.shadows?.lightness?.statistics?.stdDev;
            const midtonesStd = partitions?.midtones?.lightness?.statistics?.stdDev;
            const midtonesMean = partitions?.midtones?.lightness?.statistics?.mean;

            if (global?.lightness?.dynamicRange === 'COMPLETE' &&
                blacksMean != null && highlightsMean != null &&
                blacksMean <= scaleToHsl(30) &&
                highlightsMean >= scaleToHsl(180)) {
                features.push('highContrast');
            }

            if (global?.lightness?.level === 'DARK' &&
                shadowsStd != null && midtonesStd != null &&
                shadowsStd < scaleToHsl(10) &&
                midtonesStd < scaleToHsl(20)) {
                features.push('lowKey');
            }

            if (global?.lightness?.level === 'BRIGHT' &&
                highlightsMean != null && midtonesMean != null &&
                highlightsMean >= scaleToHsl(190) &&
                midtonesMean >= scaleToHsl(120)) {
                features.push('highKey');
            }

            return features;
        }
    },
    DETAIL_FEATURES: {
        condition: (partitions) => {
            const details = [];
            const blacksStd = partitions?.blacks?.lightness?.statistics?.stdDev;
            const shadowsStd = partitions?.shadows?.lightness?.statistics?.stdDev;
            const highlightsStd = partitions?.highlights?.lightness?.statistics?.stdDev;
            const whitesStd = partitions?.whites?.lightness?.statistics?.stdDev;

            if (blacksStd != null && shadowsStd != null &&
                blacksStd > scaleToHsl(5) &&
                shadowsStd > scaleToHsl(8)) {
                details.push('richShadowDetail');
            }

            if (highlightsStd != null && whitesStd != null &&
                highlightsStd > scaleToHsl(8) &&
                whitesStd > scaleToHsl(5)) {
                details.push('wellControlledHighlight');
            }

            return details;
        }
    },
    PARTITION_FEATURES: {
        condition: (partitions) => {
            const features = [];
            const blacks = partitions?.blacks?.lightness;
            const shadows = partitions?.shadows?.lightness;
            const highlights = partitions?.highlights?.lightness;
            const whites = partitions?.whites?.lightness;
            const midtones = partitions?.midtones?.lightness;

            if ((blacks?.dynamicRange && blacks.dynamicRange !== 'LIMITED') ||
                (shadows?.dynamicRange && shadows.dynamicRange !== 'LIMITED')) {
                features.push('richShadow');
            } else if (blacks?.level === 'DARK' || shadows?.level === 'DARK') {
                features.push('concentratedShadow');
            }

            if ((highlights?.dynamicRange && highlights.dynamicRange !== 'LIMITED') ||
                (whites?.dynamicRange && whites.dynamicRange !== 'LIMITED')) {
                features.push('richHighlight');
            } else if (highlights?.level === 'BRIGHT' || whites?.level === 'BRIGHT') {
                features.push('brightHighlight');
            }

            if (midtones?.dynamicRange === 'LIMITED') {
                features.push('compressedMidtone');
            } else if (midtones?.dynamicRange === 'COMPLETE') {
                features.push('balancedMidtone');
            }

            return features;
        }
    }
};
